import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CompanyContextService } from '../../core/services/company-context.service';
import { VendorContextService } from './vendor-context.service';

/** The Vendor Portal's routes: only for a vendor's user; anyone else goes to the company app. */
export const vendorGuard: CanActivateFn = async () => {
  const vendors = inject(VendorContextService);
  const router = inject(Router);
  return (await vendors.resolve()) ? true : router.createUrlTree(['/select-company']);
};

/**
 * The company app's routes: a vendor's user (who has no company) is sent to the Vendor Portal.
 * A user with a company is never a vendor's here, so they go straight through without asking.
 */
export const notVendorGuard: CanActivateFn = async () => {
  const companies = inject(CompanyContextService);
  if (companies.hasCompany()) return true;
  const vendors = inject(VendorContextService);
  const router = inject(Router);
  return (await vendors.resolve()) ? router.createUrlTree(['/vendor/home']) : true;
};
